export class BotatoWebSocketEvent {
    public static MESSAGE = 'message';
    public static EVENT = 'event';
    public static HISTORY = 'history';
    public static CONNECT = 'connect';
    public static DISCONNECT = 'disconnect';
    public static AUTHENTICATION = 'authentication';
    public static RETRY_AFTER_AUTH_FAILED = 'RETRY_AFTER_AUTH_FAILED';
    public static UNREAD_STATUS = 'unread_status';
    public static MARK_AS_READ = 'mark_as_read';
}
